import { Injectable, Optional, Inject, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ContentPage } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class ContentPagesService {
  #http = inject(HttpClient);
  #BASE_URL = inject(BASE_URL, { optional: true });

  getPages() {
    return this.#http.get<ContentPage[]>(`${this.#BASE_URL}api/pages`);
  }

  getSubPages(id: number) {
    return this.#http.get<ContentPage[]>(`${this.#BASE_URL}api/pages/${id}/sub-pages`);
  }
}
